import React from 'react';

const PLATFORM_CONFIG = {
  'google-ads': { src: '/google_ads-512.webp', label: 'Google Ads', color: '#4285F4', initial: 'G' },
  'meta': { src: '/6033716.png', label: 'Meta Ads', color: '#1877F2', initial: 'M' },
  'ga4': { src: '/GA4logoicon.svg', label: 'GA4', color: '#E37400', initial: 'A' },
  'ikas': { src: '/ikaslogo.webp', label: 'IKAS', color: '#6366F1', initial: 'I' },
  'shopify': { src: '/shopify-logo.svg', label: 'Shopify', color: '#96BF48', initial: 'S' },
  'woo': { src: '/woocommerceicon.png', label: 'WooCommerce', color: '#96588A', initial: 'W' },
  'adjust': { src: '/adjustlogopng.png', label: 'Adjust', color: '#FF4C3B', initial: 'A' },
  'criteo': { src: '/CRcriteopng.png', label: 'Criteo', color: '#F48120', initial: 'C' },
};

const SIZES = { sm: 16, md: 20, lg: 28 };

export function PlatformLogo({ platform, size = 'md' }) {
  const config = PLATFORM_CONFIG[platform];
  if (!config) return null;

  const px = SIZES[size] || SIZES.md;

  return (
    <img
      src={config.src}
      alt={config.label}
      width={px}
      height={px}
      className="object-contain flex-shrink-0"
      style={{ width: px, height: px }}
      onError={(e) => {
        // Fallback: replace with colored text initial
        const parent = e.target.parentNode;
        const span = document.createElement('span');
        span.textContent = config.initial;
        span.style.cssText = `display:inline-flex;align-items:center;justify-content:center;width:${px}px;height:${px}px;border-radius:4px;background:${config.color};color:#fff;font-size:${Math.round(px * 0.5)}px;font-weight:700;flex-shrink:0;`;
        parent.replaceChild(span, e.target);
      }}
    />
  );
}

export { PLATFORM_CONFIG };
